<div class="flex flex-column w-full align-items-center">
  <div class="dropdown-wrap w-full" [class.with-icon]="hasIcon()">
  @if (hasIcon()) {
    <span class="dropdown-icon"><ng-content select="[dropdownIcon]"></ng-content></span>
  }
  <p-select
    [autofocus]="false"
    class="w-full"
    #dropdownElement
    [fluid]="true"
    (onChange)="handleOnItemChange($event)"
    [disabled]="ctrlDisabled()"
    [filterBy]="ctrlFilterBy()"
    [filterPlaceholder]="ctrlFilterPlaceholder()"
    [filter]="canFilter()"
    [formControl]="formCtrl()"
    [group]="isGrouped()"
    [inputId]="formCtrlId()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [options]="options()"
    [placeholder]="ctrlPlaceholder()"
    [showClear]="canClear()"
    [styleClass]="ctrlStyleClass()"
    [panelStyleClass]="ctrlItemStyleClass()"
    [tooltip]="ctrlTooltip()"
    [dataKey]="ctrlDataKey()"
    [appendTo]="ctrlAppendTo()"
    [editable]="isEditable()"
    [emptyMessage]="ctrlEmptyMessage()"
    filterMatchMode="contains"
    (onBlur)="handleEnterOnBlur()"
  >
    <ng-template #selectedItem let-selectedOption>
      @if (selectedOption) {
        <div class="flex items-center gap-2">
          <div class="text-md-regular text-gray-900">
            {{ optionLabel() ? selectedOption[optionLabel()!] : selectedOption }}
          </div>
        </div>
      }
    </ng-template>

    <ng-template let-outerContext pTemplate="item">
      @if (item()) {
        <!-- template outlet for custom item -->
      }
    </ng-template>
  </p-select>
  </div>

  @if (!hideErrors()) {
    <app-error-required class="mt-2" [formCtrl]="formCtrl()"></app-error-required>
    <app-error-min class="mt-2" [formCtrl]="formCtrl()"></app-error-min>
  }
</div>
